// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import requests from './newAxios'
import VueScroller  from "vue-scroller";
import toast  from "./components/toast";
import './openid'
Vue.prototype.rq = requests // 此处命名为rq,你可以改

let debug = new URL(window.location.href).searchParams.get('debug')
if(debug){
    let elm = document.createElement('script');
    elm.src = 'https://oss.eventnet.cn/H5/public/vconsole.min.js';
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(elm, s);
}else{
    window['console']['log'] = function (){}
}

Vue.use(VueI18n)
Vue.use(VueScroller)
Vue.component('toast',toast)
Vue.config.productionTip = false

const i18n = new VueI18n({
    locale: localStorage.getItem("lang") || localStorage.setItem("lang", 'zh'),
    messages: {
        zh: require("./i18n/zh"),
        en: require("./i18n/en")
    }
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js